export default "__VITE_ASSET__BFZoeM5U__"